<template>
  <div id="app">
    <div
      class="file-wrapper"
      :class="{
        onHoldingFileContainer: dragover,
        'file-wrapper-none-added': attachments && attachments.length === 0,
      }"
      @dragover.prevent="dragover = true"
      @drop.prevent="handleFileInput"
      @dragenter.prevent="dragover = true"
      @dragleave.prevent="dragover = false"
    >
      <input
        ref="file"
        type="file"
        name="file"
        multiple="True"
        accept="audio/*,video/*,image/*, .docx, .xlsx, .pptx, text/plain, application/pdf"
        @change="handleFileInput"
      />

      <div v-if="attachments && attachments.length > 0" class="pa-2">
        <FileChip
          :attachments="attachments"
          :disableClick="disableClick"
          :close="close"
        />
      </div>
      <span v-else class="pa-4 noAttachmentsAdded text-center">
        <v-icon class="mb-1" x-large>mdi-cloud-upload</v-icon>
        <h4>
          {{
            $vuetify.breakpoint.mobile
              ? "Trykk her for å ta bilde eller legge til filer!"
              : "Dropp eller trykk her for å legge til filer!"
          }}
        </h4>
      </span>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import FileChip from "@/components/shared/attachments/FileChip.vue";
import { readFile } from "@/helpers/files";
import { fileObject } from "@/types/fileInterface";

export default Vue.extend({
  props: {
    value: {
      type: Array as () => Array<fileObject>,
    },
    disableClick: {
      type: Boolean,
      default: false,
    },
    close: {
      type: Boolean,
      default: true,
    },
  },
  data: function () {
    return {
      files: [],
      dragover: false,
    };
  },
  methods: {
    async handleFileInput(e) {
      this.dragover = false;
      var files = [];
      if (e.type === "drop") {
        files = e.dataTransfer.files;
      } else {
        files = e.target.files;
      }

      if (files?.length > 0) {
        [...files].forEach((f) => {
          this.files.push(f);
        });

        this.attachmentsAdded(files);
      }
    },
    async attachmentsAdded(data) {
      await Promise.all(
        [...data].map(async (x) => {
          await readFile(x).then((y) => {
            var fileObject = {
              base64: y,
              bufferGuid: null,
              contentType: x.type,
              dataCompressed: null,
              fileName: x.name,
              status: 2,
            } as fileObject;
            this.attachments.push(fileObject);
          });
        })
      );
      this.$emit("change");
    },
    addAttachment() {
      const file: any = this.$refs.file;
      file.click();
    },
  },

  computed: {
    attachments: {
      get(): Array<fileObject> {
        return this.value;
      },
      set(value: Array<fileObject>) {
        this.$emit("input", value);
      },
    },
  },
  components: {
    FileChip,
  },
});
</script>

<style lang="scss" scoped>
.file-wrapper {
  display: flex;
  width: 100%;
  position: relative;

  color: var(--v-primary-base);
  transition: background-color 0.4s;
  -webkit-transition: background-color 0.4s;
  -o-transition: background-color 0.4s;
  -moz-transition: background-color 0.4s;
  // &:hover {
  // background-color: rgb(230, 230, 230);
  // }
}
.file-wrapper input {
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
  opacity: 0;
  filter: alpha(opacity=0);
  height: 100%;
  width: 100%;
}
.file-wrapper-none-added {
  border-style: dashed;
  border-color: var(--v-primary-base);
  border-width: 1px;
  background-color: var(--v-cardSurface-base);
}

.onHoldingFileContainer {
  background-color: var(--v-primary-base);
  color: white;
}
.noAttachmentsAdded {
  width: 100%;
}
</style>
